/* global jQuery */
export class ModalPopup {
  constructor(config, defaultOptions) {
    this.config = config;
    this.defaultOptions = this.normalizeOptions(defaultOptions);
  }

  setup() {
    if (!this.isSetup) {
      this.options = this.normalizeOptions(null);

      const elements = this.config.Elements;

      // If the popup is wrapped in a <template> element, then clone it and append it to the DOM now:
      if (elements.template) {
        const template = document.getElementById(elements.template);
        if (template) {
          const clone = template.content.firstElementChild.cloneNode(true);
          document.body.appendChild(clone);
        }
      }

      this.modalTitle = document.getElementById(elements.title);
      this.modalBody = document.getElementById(elements.body);
      this.closeBtn = document.getElementById(elements.closeBtn);
      this.okBtn = document.getElementById(elements.okBtn);
      this.yesBtn = document.getElementById(elements.yesBtn);
      this.noBtn = document.getElementById(elements.noBtn);
      this.popup = jQuery('#' + elements.popup);

      this.popup.on('show.bs.modal', (e) => {
        if (!this.isActive) { return; }
        const onShowing = this.options.onShowing || this.defaultOptions.onShowing;
        if (typeof onShowing !== 'undefined' && onShowing !== null) {
          onShowing(e);
        }
      });
      this.popup.on('shown.bs.modal', (e) => {
        if (!this.isActive) { return; }
        const onShown = this.options.onShown || this.defaultOptions.onShown;
        if (typeof onShown !== 'undefined' && onShown !== null) {
          onShown(e);
        }
      });
      /* We need to use the click event to set this.lastClickedButton since Safari (at least on ios)
       * doesn't automatically update document.activeElement on button clicks. */
      this.popup.on('click', 'button', event => {
        if (!this.isActive) { return; }
        this.lastClickedButton = event.target;
      });
      this.popup.on('hide.bs.modal', (e) => {
        if (!this.isActive) { return; }
        const onClosing = this.options.onClosing || this.defaultOptions.onClosing;
        if (typeof onClosing !== 'undefined' && onClosing !== null) {
          onClosing(e);
        }
        if (this.lastClickedButton) {
          if (this.lastClickedButton === this.yesBtn) {
            const onYes = this.options.onYes || this.defaultOptions.onYes;
            if (typeof onYes !== 'undefined' && onYes !== null) {
              onYes(e);
            }
          } else {
            const onNo = this.options.onNo || this.defaultOptions.onNo;
            if (typeof onNo !== 'undefined' && onNo !== null) {
              onNo(e);
            }
          }
        }
      });
      this.popup.on('hidden.bs.modal', (e) => {
        if (!this.isActive) { return; }
        const onClosed = this.options.onClosed || this.defaultOptions.onClosed;
        if (typeof onClosed !== 'undefined' && onClosed !== null) {
          onClosed(e);
        }
        this.isActive = false;
      });
      this.isSetup = true;
    }
  }

  normalizeOptions(options) {
    options = options || {};
    options.onShowing = options.onShowing || null;
    options.onShown = options.onShown || null;
    options.onClosing = options.onClosing || null;
    options.onClosed = options.onClosed || null;
    options.onYes = options.onYes || null;
    options.onNo = options.onNo || null;
    //options.closeBtnAriaLabel = options.closeBtnAriaLabel || null;
    //options.okBtnLabel = options.okBtnLabel || null;
    return options;
  }

  updateCloseBtnAriaLabel() {
    const label = this.options.closeBtnAriaLabel || this.defaultOptions.closeBtnAriaLabel;
    if (typeof label !== 'undefined') {
      this.closeBtn.setAttribute('aria-label', label);
    }
  }

  updateButtonLabels() {
    let label = this.options.okBtnLabel || this.defaultOptions.okBtnLabel;
    if (typeof label !== 'undefined' && typeof this.okBtn != 'undefined') {
      this.okBtn.textContent = label;
    }
    label = this.options.yesBtnLabel || this.defaultOptions.yesBtnLabel;
    if (typeof label !== 'undefined' && typeof this.yesBtn != 'undefined') {
      this.yesBtn.textContent = label;
    }
    label = this.options.noBtnLabel || this.defaultOptions.noBtnLabel;
    if (typeof label !== 'undefined' && typeof this.noBtn != 'undefined') {
      this.noBtn.textContent = label;
    }
  }

  display(title, bodyHtml, options) {
    if (!this.isSetup) {
      this.setup();
    }
    this.options = this.normalizeOptions(options);
    this.updateCloseBtnAriaLabel();
    this.updateButtonLabels();
    this.modalTitle.textContent = title;
    this.modalBody.innerHTML = bodyHtml;
    this.isActive = true;
    this.popup.modal('show');
  }

  close() {
    this.popup.modal('hide');
  }

}
